export const commonContent = {
  orderBodyContent: {
    nextOnlyLabel: 'One time',
    outOfStockLabel: 'Out of Stock',
    quantityLabel: 'Quantity:',
    productHiddenLabel: 'Product',
    productsSubtitle: 'Products',
    subscriptionTitle: 'Subscription',
    otpTitle: 'This order only'
  },
  referFriendCard: {
    title: 'Refer Friends',
    text: 'Get $15 for every friend you refer once they make their first purchase.'
  },
  slider: {
    empty: {
      title: 'Our Subscriptions'
    },
    notEmpty: {
      title: 'The AG1 Shop',
      description: 'Available exclusively to members'
    },
    cardContent: {
      addToSubscription: 'Add to Subscription',
      addedToSubscription: 'Added To Subscription',
      addToNextOrder: 'Add to Next Order',
      addedToNextOrder: 'Added To Next Order',
      maxQuantityReached: 'Max quantity reached'
    }
  },
  buttons: {
    subscribeAndSave: 'Subscribe & Save',
    subscribe: 'Subscribe',
    delete: 'Delete'
  },
  status: {
    fulfilled: 'Fulfilled',
    partial: 'Partially fulfilled',
    paid: 'Shipment in process',
    refunded: 'Refunded',
    partially: 'Partially refunded',
    unpaid: 'Unpaid'
  },
  statusV2: {
    Unfulfilled: 'Preparing',
    Fulfilled: 'Shipped',
    'On hold': 'Preparing'
  }
};
